import useWidth from './useWidth';

export default () => {
  const width = useWidth();

  const isMobile = width === 'xs';
  const isTablet = width === 'sm';
  const isDesktop = width === 'lg';

  return {
    isMobile,
    isTablet,
    isDesktop,
  };
};
